<template>
  <div class="insiderBox" :style="{ backgroundColor: bgColor && bgColor }">
    {{ iName }}
  </div>
</template>

<script>
import Vue from 'vue'
import { Icon } from 'vant'
Vue.use(Icon)

export default {
  name: 'InsiderBox',
  props: ['insiderName', 'idx', 'bColor', 'id'],
  data() {
    return {
      iName: this.insiderName,
      index: this.idx,
      bgColor: this.bColor,
    }
  },
}
</script>

<style lang="less" scoped>
.insiderBox {
  width: 104px;
  height: 40px;
  border-radius: 2px;
  margin-bottom: 12px;
  border: 1px solid #d9d9d9;
  font-size: 14px;
  display: flex;
  justify-content: space-around;
  align-items: center;
  margin-right: 8px;
}
</style>
